module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "servicios"
    }
  }, [_c('div', {
    staticClass: "col-md-12 flecha-container"
  }, [_c('h1', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1500"
    }
  }, [_vm._v("SERVICIOS")]), _vm._v(" "), _c('img', {
    staticClass: "flecha",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1500",
      "src": require("imgs/icons/Flecha_Blanca.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "service-container"
  }, [_c('div', {
    staticClass: "service-redbox",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1500"
    }
  }, [_c('img', {
    staticClass: "service-img",
    attrs: {
      "src": require("imgs/icons/Servicios_Herramientas.png")
    }
  }), _vm._v(" "), _c('h3', {
    attrs: {
      "name": "img-text"
    }
  }, [_vm._v("LOGÍSTICA")])]), _vm._v(" "), _c('div', {
    staticClass: "service-redbox",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1500"
    }
  }, [_c('img', {
    staticClass: "service-img",
    attrs: {
      "src": require("imgs/icons/Servicios_Location.png")
    }
  }), _vm._v(" "), _c('h3', {
    attrs: {
      "name": "img-text"
    }
  }, [_vm._v("GPS")])]), _vm._v(" "), _c('div', {
    staticClass: "service-redbox",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1500"
    }
  }, [_c('img', {
    staticClass: "service-img",
    attrs: {
      "src": require("imgs/icons/Servicios_Ojo.png")
    }
  }), _vm._v(" "), _c('h3', {
    attrs: {
      "name": "img-text"
    }
  }, [_vm._v("MONITOREO")])]), _vm._v(" "), _c('div', {
    staticClass: "service-redbox",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1500"
    }
  }, [_c('img', {
    staticClass: "service-img",
    attrs: {
      "src": require("imgs/icons/Servicios_Seguro.png")
    }
  }), _vm._v(" "), _c('h3', {
    attrs: {
      "name": "img-text"
    }
  }, [_vm._v("SEGURIDAD")])]), _vm._v(" "), _c('div', {
    staticClass: "service-redbox",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1500"
    }
  }, [_c('img', {
    staticClass: "service-img",
    attrs: {
      "src": require("imgs/icons/Servicios_Truck.png")
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "cruce-front",
    attrs: {
      "name": "img-text"
    }
  }, [_vm._v("CRUCE FRONTERIZO")])]), _vm._v(" "), _c('div', {
    staticClass: "service-redbox",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1500"
    }
  }, [_c('img', {
    staticClass: "service-img",
    attrs: {
      "src": require("imgs/icons/Servicios_Velocidad.png")
    }
  }), _vm._v(" "), _c('h3', {
    attrs: {
      "name": "img-text"
    }
  }, [_vm._v("ENTREGAS")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-146d8e10"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Servicios.vue
// module id = 73
// module chunks = 0